"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transitionTimeouts = exports.transitionStyles = void 0;
exports.transitionStyles = {
    entering: { opacity: 0 },
    entered: {
        opacity: 1,
        transition: 'opacity 300ms, transform 300ms',
    },
    exited: {
        opacity: 0,
    },
};
exports.transitionTimeouts = {
    appear: 0,
    enter: 300,
    exit: 100,
};
//# sourceMappingURL=incoming_call_notification_transition.js.map